import { debug } from "../../utils";

export const ACTION_DEVICE_LOADED = "ACTION_DEVICE_LOADED";
export const ACTION_DEVICE_CHANGELOG_LOADED = "ACTION_DEVICE_CHANGELOG_LOADED";

export function ChangeDetailsPageReducer(state = {}, action) {
    switch (action.type) {
        case ACTION_DEVICE_LOADED: {
            debug(`ChangeDetailsPageReducer ${ACTION_DEVICE_LOADED} is being processed...`)
            return { ...state, ...action.payload };
        }
        case ACTION_DEVICE_CHANGELOG_LOADED: {
            debug(`ChangeDetailsPageReducer ${ACTION_DEVICE_CHANGELOG_LOADED} is being processed...`)
            return { ...state, ...action.payload };
        }
        default:
            return state;
    }
}